import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';

import { ProductList, VehicleList } from '@C/CreditCustomers/_utils/';
import services from '@C/CreditCustomers/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import { DateRangeFilter, ShiftsList, StaffList } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Slip #',
    key: 'credit_slip',
    formatter(props) {
      return <>{props.slip_number}</>;
    },
  },
  {
    name: 'Staff',
    key: 'cashier',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Customer',
    key: 'customer',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Vehicle',
    key: 'credit_slip',
    formatter(props) {
      return <>{props.vehicle_number || '---'}</>;
    },
  },
  {
    name: 'Product',
    key: 'credit_slip',
    formatter(props) {
      return <>{props.product.product}</>;
    },
  },
  {
    name: 'Rate',
    key: 'credit_slip',
    formatter(props) {
      return <>{props.product.price}</>;
    },
  },
  {
    name: 'Qty',
    key: 'quantity',
  },
  {
    name: 'Amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.amount)}</>;
    },
  },
  {
    name: 'Amount received',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.amount_received)}</>;
    },
  },
  {
    name: 'Balance',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.balance)}</>;
    },
  },
];

class CustomerLedgerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slipList: [],
      selectedId: '',
      showModal: false,
      staff_id: '',
      uuid: this.props.match.params.uuid,
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      product_id: '',
      customer_id: '',
      shift_id: '',
      slip_no: '',
      vehicle_number: '',
      loading: false,
      productList: this.props.products,
      customerList: this.props.customers,
      limit: 20,
      offset: 1,
      count: 0,
    };

    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getCreditLedgerList();
  }

  getCreditLedgerList = () => {
    const { uuid } = this.state;
    services
      .getCreditLedgerList(this.state, uuid)
      .then((response) => {
        this.setState({
          slipList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDateChange = (e) => {
    if (Array.isArray(e)) {
      const [start_date, end_date] = e;
      this.setState({
        start_date: start_date || '',
        end_date: end_date || '',
      });
      return;
    }

    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleShiftChange = (e) => {
    this.setState({ shift_id: e.value });
  };

  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  handleBillChange = (e) => {
    this.setState({ slip_no: e.target.value });
  };

  handleProductChange = (e) => {
    this.setState({ product_id: e?.value || '' });
  };

  handleCustomerChange = (e) => {
    this.setState({ customer_id: e.value });
  };

  handleVehicleChange = (e) => {
    this.setState({ vehicle_number: e?.value || '' });
  };

  handleCategoryChange = (e) => {
    this.setState({ customer_id: e });
  };
  handlePagination = (e) => {
    this.setState({ offset: e, loading: true }, function () {
      this.getCreditLedgerList();
    });
  };
  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getCreditLedgerList();
      },
    );
  };
  editItem = (selectedId) => {
    this.setState({ selectedId: selectedId, showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  resetFilter = () => {
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_id: '',
        customer_id: '',
        loading: false,
        slip_number: '',
        vehicle_number: '',
      },
      function () {
        //this.getCreditLedgerList();
      },
    );
  };

  confirmDelete = (id) => {
    confirmAlert({
      title: 'Confirm sale deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(id),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (id) => {
    const headers = authHeader(1);
    axios
      .delete(`${process.env.API_URL}/payment/?transaction_id=${id}`, {
        headers,
      })
      .then((response) => {
        toast.success('Sale deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getCreditLedgerList();
      });
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getCreditLedgerList();
    });
  };

  render() {
    const { slipList } = this.state;

    return (
      <section className="widget full-width list-table">
        <header>
          <h3>Customer Ledger</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group with-icon">
                <label>Results to display - (Total: {this.state.count})</label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  />
                </form>
              </div>
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>Staff:</label>
                <StaffList
                  value={this.state.staff_id}
                  onChange={this.handleStaffChange}
                  staffType={['Cashiers', 'Managers', 'Dealer']}
                />
              </div>
              <div className="filter-group">
                <label>Shift:</label>
                <ShiftsList
                  value={this.state.shift_id}
                  onChange={this.handleShiftChange}
                />
              </div>
              <div className="filter-group">
                <label>Product:</label>
                <ProductList
                  onProductChange={this.handleProductChange}
                  value={this.state.product_id}
                  options={this.state.productList}
                />
              </div>
              <div className="filter-group">
                <label>Vehicle:</label>
                <VehicleList
                  value={this.state.vehicle_number}
                  handleDropdownChange={this.handleVehicleChange}
                  selectedCustomerId={this.state.customer_id}
                />
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${this.state.loading ? 'loading' : ''}`}
                  disabled={this.state.loading}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Apply filter
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {this.state.customer_id && (
              <div className="mini-summary">
                <ul>
                  <li>
                    <span> Total outstanding amount: </span>
                    <span>
                      {new Intl.NumberFormat('en-IN', {}).format(
                        parseFloat(slipList[0]?.balance).toFixed(2) || 0,
                      )}
                    </span>
                  </li>
                </ul>
              </div>
            )}
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={slipList}
                      offset={this.state.offset}
                      count={this.state.count}
                      limit={this.state.limit}
                      handlePagination={this.handlePagination}
                      hideActions={true}
                      exportOptions={{
                        fileName: `Credit Ledger - ${this.state.start_date} to ${this.state.end_date}.pdf`,
                        reportName: 'Credit Ledger Report',
                        reportDate: `Date - ${dayjs(
                          this.state.start_date,
                        ).format(
                          'D MMM YY',
                        )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                        reportCustomerName: `${slipList[0]?.customer?.first_name} ${slipList[0]?.customer?.last_name}`,
                        reportTotal: `Total outstanding amount -  ${
                          parseFloat(slipList[0]?.balance).toFixed(2) || 0
                        }`,
                        reportQuantity: '',
                        reportSales: '',
                        reportTesting: '',
                        reportBowser: '',
                      }}
                    />
                  </>
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { CustomerLedgerList };
